import Vue from 'vue';

const state = {
  roleTemplates: {}
}

const getters = {

  roleTemplate (state) {
    return id => {
      if (id in state.roleTemplates) return state.roleTemplates[id];
      else return false;
    }
  },

  roleTemplates (state) {
    return state.roleTemplates;
  }
}

const mutations = {

  storeRoleTemplates (state, roleTemplates) {
    
    roleTemplates.forEach(roleTemplate => {
      var current = state.roleTemplates[roleTemplate._id] || {};
      Vue.set(state.roleTemplates, roleTemplate._id, {
        ...current,
        ...roleTemplate
      });
    });
  },

  removeRoleTemplate (state, id) {
    if (id in state.roleTemplates) Vue.delete(state.roleTemplates, id);
  },

  clearRoleTemplates () {
    Vue.set(state, 'roleTemplates', {});
  }

}

const actions = {
  
  loadRoleTemplates ({commit}, params) {
    var filters = params.filters || {};

    if (!params.company) {
      return Promise.reject('state.roleTemplate - load Role Templates - Missing required param "company"');
    }

    var queryParams = {
      ...filters
    };

    return window.server.getReq('company/' + params.company + '/roles', {
      params: queryParams
    })
    .then(data => {
      commit('storeRoleTemplates', data);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },
 
  loadRoleTemplate ({commit, dispatch}, params) {
    var filters = params.filters || {};

    if (!params.role) {
      return Promise.reject('state.roleTemplate - load Role Template - Missing required param "role"');
    }

    var queryParams = {
      ...filters
    };

    return window.server.getReq('role/' + params.role, {
      params: queryParams
    })
    .then(data => {
      commit('storeRoleTemplates', [data]);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  createRoleTemplate ({commit, dispatch}, params) {
    if (!params.company || !params.role) {
      return Promise.reject('state.roleTemplate - create Role Template - Missing required param "company" | "role"');
    }

    return window.server.postReq('company/' + params.company + '/role', {
      role: params.role
    })
    .then(data => {
      return dispatch('loadRoleTemplate', {role: data._id});
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  deleteRoleTemplate ({commit}, params) {
    if (!params.role) {
      return Promise.reject('state.roleTemplate - delete Role Template - Missing required param "role"');
    }

    return window.server.delReq('role/' + params.role)
    .then(data => {
      commit('removeRoleTemplate', params.role);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    })
  },

  updateRoleTemplate ({commit, dispatch}, params) {
    if (!params.role) {
      return Promise.reject('state.roleTemplate - update Role Template - Missing required param "role"');
    }

    return window.server.putReq('role/' + params.role._id, {
      role: params.role
    })
    .then(data => {
      return dispatch('loadRoleTemplate', {role: params.role._id});
    })
    .catch(e => {
      return Promise.reject(e);
    });
  } 
  
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/roleTemplate.js